<template>
  <div class="event">
      <p>{{ $store.getters['getClientMeta'].name }}</p>
      <h3 class="line-title">Bonuslar</h3>
      <form v-on:submit.prevent="filter" class="top-filter">
        <div class="buttons">
          <button  type="button" @click="status = 'receivable'" class="button" :class="status == 'receivable' ? 'active' : ''">Alınabilir</button>
          <button  type="button" @click="status = 'active'" class="button" :class="status == 'active' ? 'active' : ''">Aktif</button>
          <button  type="button" @click="status = 'history'" class="button" :class="status == 'history' ? 'active' : ''">Geçmiş</button>
        </div>
      </form>
      <div class="user-content-inc " :class="{ 'table-panel' : status == 'history'}">
        <Loader v-if="loading" :style="!isMobile ? 'margin-top: -35px;' : ''" />

        <slot v-if="!loading">
          <ActiveBonus :openBonus="openBonus" v-if="status == 'active'"></ActiveBonus>
          <AvailableBonuses :btnLoading="btnLoading" :receivable="receivable" @openBonus="activePromo = $event" v-if="!activePromo && isMobile && status == 'receivable' || !isMobile && status == 'receivable'"></AvailableBonuses>
          <History :finishedBonus="finishedBonus" v-if="status == 'history'"></History>
            
          <div class="promo-modal" v-if="status == 'receivable' && !_.isEmpty(activePromo)">
            <Modal @modalStatus="activePromo = $event" :isPromotion="activePromo" :isVisible="activePromo">
                  <template slot="img"><img  v-if="!_.isUndefined(activePromo.promotion)" :src="$store.state.main.cdn_url + activePromo.promotion.image_first" width="400"></template>
                  <template slot="content">
                    <div>
                      <h3 class="line-title">{{ activePromo.title }}</h3>
                      <div class="rules" style='display:none'>
                        <div class="items">
                          <span class="name">Kombine Kupon</span>
                          <span class="status">{{ (_.isNull(activePromo.total_rate) && _.isNull(activePromo.single_rate) ? $t('user.bonuses.available') : (activePromo.total_rate + ' toplam veya üstü')) }}</span>
                        </div>
                        <div class="items">
                          <span class="name">Tekli Kupon</span>
                          <span class="status">{{ (!_.isNull(activePromo.single_rate) ? activePromo.single_rate + ' ' + 'Aktif' : 'Pasif') }}</span>
                        </div>
                        <div class="items">
                          <span class="name">Minumum Oran</span>
                          <span class="status">{{ activePromo.min_rate }}</span>
                        </div>
                        <div class="items">
                          <span class="name">Maksimum Kazanç</span>
                          <span class="status">{{ ((!_.isUndefined(activePromo.max_win)) ? activePromo.max_win : '0.00') }} {{ user.currency }}</span>
                        </div>
                        <div class="items">
                          <span class="name">Çevrim şartına uymayan kupon</span>
                          <span class="status">{{ ((!_.isUndefined(activePromo.limits) && !_.isUndefined(activePromo.limits.non_compliant_coupon) && activePromo.limits.non_compliant_coupon == 1) ? 'Oynanabilir' :  'Oynanamaz') }}</span>
                        </div>
                        <div class="items">
                          <span class="name">İki Yollu Bahisler</span>
                          <span class="status">{{ ((!_.isUndefined(activePromo.two_ways) && activePromo.two_ways == 1) ? 'Oynanabilir' :  'Oynanamaz') }}</span>
                        </div>
                        <div class="items">
                          <span class="name">Yapılan bahis, alınan bonustan büyük ise</span>
                          <span class="status">{{ ((!_.isUndefined(activePromo.limits) && !_.isUndefined(activePromo.limits.amount_setting) && activePromo.limits.amount_setting == 1) ? 'Çevrimden Say' :  'Çevrimden Sayma') }}</span>
                        </div>
                        <div class="items">
                          <span class="name">Bonus Süresi </span>
                          <span class="status">{{ ((!_.isUndefined(activePromo.expire_at)) ? activePromo.expire_at : '-') }}</span>
                        </div>
                      </div>
                    <div v-html="activePromo.promotion.rules"></div>
                    <table  style='display:none' class="table">
                      <thead>
                        <tr>
                          <th>İzinler</th>
                          <th>Servisler</th>
                          <th>Çevrim Katı</th>
                          <th>Çevrimden</th>
                        </tr>
                      </thead>
                      <tbody>
                          <tr v-if="!_.isUndefined(activePromo.limits.sportsbook)">
                            <td>Spor Bahisleri</td>
                            <td>{{ activePromo.limits.sportsbook.is_active ? 'Aktif' : 'Pasif' }}</td>
                            <td>{{ ((activePromo.limits.reserve_deleted == 1 && activePromo.percent < 50) ? '-' : activePromo.limits.sportsbook.coefficient) }}</td>
                            <td>{{ activePromo.limits.sportsbook.circuit ? 'Dahil' : 'Dahil Değil' }}</td>
                          </tr>
                          <tr v-if="!_.isUndefined(activePromo.limits.slot)">
                            <td>Casino</td>
                            <td>{{ activePromo.limits.slot.is_active ? 'Aktif' : 'Pasif' }}</td>
                            <td>{{ ((activePromo.limits.reserve_deleted == 1 && activePromo.percent < 50) ? '-' : activePromo.limits.slot.coefficient) }}</td>
                            <td>{{ activePromo.limits.slot.circuit ? 'Dahil' : 'Dahil Değil' }}</td>
                          </tr>
                          <tr v-if="!_.isUndefined(activePromo.limits.casino)">
                            <td>Canlı Casino</td>
                            <td>{{ activePromo.limits.casino.is_active ? 'Aktif' : 'Pasif' }}</td>
                            <td>{{ ((activePromo.limits.reserve_deleted == 1 && activePromo.percent < 50) ? '-' : activePromo.limits.casino.coefficient) }}</td>
                            <td>{{ activePromo.limits.casino.circuit ? 'Dahil' : 'Dahil Değil' }}</td>
                          </tr>
                          <tr v-if="!_.isUndefined(activePromo.limits.poker)">
                            <td>Poker</td>
                            <td>{{ activePromo.limits.poker.is_active ? 'Aktif' : 'Pasif' }}</td>
                            <td>{{ ((activePromo.limits.reserve_deleted == 1 && activePromo.percent < 50) ? '-' : activePromo.limits.poker.coefficient) }}</td>
                            <td>{{ activePromo.limits.poker.circuit ? 'Dahil' : 'Dahil Değil' }}</td>
                          </tr>
                          <tr v-if="!_.isUndefined(activePromo.limits.bingo)">
                            <td>Bingo</td>
                            <td>{{ activePromo.limits.bingo.is_active ? 'Aktif' : 'Pasif' }}</td>
                            <td>{{ ((activePromo.limits.reserve_deleted == 1 && activePromo.percent < 50) ? '-' : activePromo.limits.bingo.coefficient) }}</td>
                            <td>{{ activePromo.limits.bingo.circuit ? 'Dahil' : 'Dahil Değil' }}</td>
                          </tr>
                          <tr v-if="!_.isUndefined(activePromo.limits.virtual)">
                            <td>Sanal Sporlar</td>
                            <td>{{ activePromo.limits.virtual.is_active ? 'Aktif' : 'Pasif' }}</td>
                            <td>{{ ((activePromo.limits.reserve_deleted == 1 && activePromo.percent < 50) ? '-' : activePromo.limits.virtual.coefficient) }}</td>
                            <td>{{ activePromo.limits.virtual.circuit ? 'Dahil' : 'Dahil Değil' }}</td>
                          </tr>
                      </tbody>
                    </table>

                    </div>
                  </template>
            </Modal>
          </div>
        </slot>
      </div>
  </div>
</template>
<script>
  import ActiveBonus from '../../components/User/Bonus/ActiveBonus'
  import AvailableBonuses from '../../components/User/Bonus/AvailableBonuses'
  import History from '../../components/User/Bonus/History'

  export default{
    data(){
      return{
        activePromo: false,
        bonusDetail: null,
        status:'',
        bonuses:[],
        receivable: [],
        bonuses:[],
        lastPayin:{},
        finishedBonus:[],
        openBonus:[],
        btnLoading: false,
        loading: false,
      }
    },
    components:{
      ActiveBonus,
      AvailableBonuses,
      History
    },
    computed:{
       user(){
         return this.$user();
       }
    },
    created(){
      this.fetchData();
    },
    methods:{
      fetchData(){
          this.loading = true;
          axios.get('/user/bonuses')
          .then((response)=>{
              this.receivable 	= response.data.receivable;
              this.bonuses 		= response.data.bonuses;
              this.lastPayin 		= response.data.lastPayin;

              this.openBonus 		= _.filter(this.bonuses, function(value, key){ if(value.status == 0){return value; }});
              this.finishedBonus 	= _.filter(this.bonuses, function(value, key){ if(value.status != 0){return value; }});
              if(!_.isEmpty(this.openBonus)){
                this.status = 'active';
              }else{
                this.status = 'receivable';
              }
          })
          .catch(() => {})
          .finally(() => {
            this.loading = false;
          });
      },
      make(val){
        this.btnLoading = true;
        axios.post('/user/bonuses', {bonus_id: val})
        .then((response)=>{
          this.status = 'active';
          this.fetchData();
          this.receivable = [];
          this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
        })
        .catch(() => {})
        .finally(() => {
          this.btnLoading = false;
        });
      }
    }
  }
</script>

<style langs='scss'>
  .promo-modal .modal-content p{
    margin: 0px;
  }
  .table{
    margin-top:10px;
  }
  #app.mobile{
    .promo-modal .modal-content{
      margin:0px !important;
    }
  .promo-modal .modal-content .rules .items {
    width: 48% !important;
  }
  }
  #app:not(.mobile) .app-modal > .content {
      width: 1000px !important;
  }
  .promo-modal .modal-content .table{
    background: #ffffff26;
    border-radius: 10px;
    tr{
      border-bottom:1px solid #ffffff26;
    }
    td,th{
      padding:10px !important;
      text-align:center
    }
  }
  .promo-modal .modal-content .rules .items {
      background: #ffffff26 !important;
      border-radius: 10px !important;
      padding: 10px !important;
      margin: 5px 1% 0px 1% !important;
      width: 23% !important;
      .name{
          opacity:0.7 !important;
        }
  }
</style>
<style>
</style>